import { useRef, useState, useEffect } from 'react';
import { Picker } from 'emoji-mart';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import Header from './components/Header';
import Messages from './components/Messages';
import Sender from './components/Sender';
import QuickButtons from './components/QuickButtons';
import { AnyFunction } from '../../../../utils/types';
import { GlobalState } from '../../../../store/types';

import './style.scss';
import { SenderPanel } from './components/Sender/components/SenderPanel';
import OperatorPrinting from './components/Messages/components/OperatorPrinting';

interface ISenderRef {
  onSelectEmoji: (event: any) => void;
}

type Props = {
  title?: string;
  subtitle: string;
  senderPlaceHolder: string;
  showCloseButton: boolean;
  disabledInput: boolean;
  autofocus: boolean;
  className: string;
  sendAudioData: AnyFunction;
  sendMessage: AnyFunction;
  toggleChat: AnyFunction;
  profileAvatar?: string;
  profileClientAvatar?: string;
  titleAvatar?: string;
  onQuickButtonClicked?: AnyFunction;
  onTextInputChange?: (event: any) => void;
  sendButtonAlt: string;
  showTimeStamp: boolean;
  emojis?: boolean;
};

function Conversation({
  title,
  subtitle,
  senderPlaceHolder,
  showCloseButton,
  disabledInput,
  autofocus,
  className,
  sendMessage,
  sendAudioData,
  toggleChat,
  profileAvatar,
  profileClientAvatar,
  titleAvatar,
  onQuickButtonClicked,
  onTextInputChange,
  sendButtonAlt,
  showTimeStamp,
  emojis
}: Props) {
  const [containerDiv, setContainerDiv] = useState<HTMLElement | null>();
  const useButton = useSelector((state: GlobalState) => state.settings.use_button);

  useEffect(() => {
    const containerDiv = document.getElementById('rcw-conversation-container');
    setContainerDiv(containerDiv);
  }, []);



  const [pickerOffset, setOffset] = useState(0)
  const senderRef = useRef<ISenderRef>(null!);
  const [pickerStatus, setPicket] = useState(false)

  const onSelectEmoji = (emoji) => {
    senderRef.current?.onSelectEmoji(emoji)
  }

  const togglePicker = () => {
    setPicket(prevPickerStatus => !prevPickerStatus)
  }

  const handlerSendMsn = (event) => {
    sendMessage(event)
    if (pickerStatus) setPicket(false)
  }

  return (

    <div id="rcw-conversation-container"
      className={cn('rcw-conversation-container', className)} aria-live="polite">
      <Header
        title={title}
        subtitle={subtitle}
        toggleChat={toggleChat}
        showCloseButton={showCloseButton}
        titleAvatar={titleAvatar}
        onSelectCommand={handlerSendMsn}
        useButton={useButton}
      />
      <Messages
        profileAvatar={profileAvatar}
        profileClientAvatar={profileClientAvatar}
        showTimeStamp={showTimeStamp}
        sendMessage={handlerSendMsn}
      />
      <OperatorPrinting />
      <QuickButtons onQuickButtonClicked={onQuickButtonClicked} />
      {emojis && pickerStatus && (<Picker
        style={{ position: 'absolute', bottom: pickerOffset, left: '0', width: '100%' }}
        onSelect={onSelectEmoji}
      />)}
      <SenderPanel sendMessage={handlerSendMsn}>
        <Sender
          ref={senderRef}
          sendMessage={handlerSendMsn}
          sendAudioData={sendAudioData}
          placeholder={senderPlaceHolder}
          disabledInput={disabledInput}
          autofocus={autofocus}
          onTextInputChange={onTextInputChange}
          buttonAlt={sendButtonAlt}
          onPressEmoji={togglePicker}
          onChangeSize={setOffset}
        />
      </SenderPanel>
    </div>

  );
}

export default Conversation;
